import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../style/theme'
import { TableV2Td } from '../index.styled'

export const TableV2RowStyled = styled.div`
	font-size: 1rem;
	position: relative;
	min-height: 5em;
	display: grid;
	grid-template-columns: ${(props) => props.columns};
	gap: 1.25em;
	padding: .3em 1.25em .3em 1.88em;
	background: ${colorTheme.tableV2.background};
	align-items: center;
	border-bottom: 1px solid ${colorTheme.tableV2.border};

	&:nth-child(even) {
		background: ${colorTheme.tableV2.backgroundDark};
	}

	&.static-bg {
		&:nth-child(even) {
			background: ${colorTheme.tableV2.background};
		}
	}

	&.total {
		border-top: 2px solid ${colorTheme.tableV2.border};
		background: ${colorTheme.tableV2.backgroundTotal};
		border-bottom: none;
	}

	&.disabled {
		> ${TableV2Td}:not(.not-disabled) {
			div {
				color: ${colorTheme.tableV2.disabled.text};
			}

			span {
				background: ${colorTheme.tableV2.disabled.text};
			}
		}
	}

	&.active {
		border-color: transparent;
		z-index: 2;
		box-shadow: 0px 0px 0px 2px ${colorTheme.tableV2.active.border};

		p {
			color: ${colorTheme.tableV2.active.text};
		}

		span {
			background: ${colorTheme.tableV2.active.border};
		}

		${TableV2Td} .order-type {
			color: ${colorTheme.tableV2.active.backgroundOrderType};
			background-color: ${colorTheme.tableV2.active.backgroundOrderType};

			svg {
				fill: white !important;
			}
		}

		${TableV2Td} .delivery, .order-type-text, .delivery-text {
			color: ${colorTheme.tableV2.active.backgroundOrderType};
		}

		${TableV2Td}:not(.const-color):not(.unpaid) > div, .light {
			color: ${colorTheme.tableV2.active.text} !important;

			svg:not(button > svg):not(.unpaid) {
				fill: ${colorTheme.tableV2.active.text};
			}
		}
	}

	@media screen and (max-width: ${theme.point820}) {
		height: auto;
		padding: 0;
		gap: 0;
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		border-bottom: 3px solid ${colorTheme.tableV2.mobileBorderBold};

		&.total {
			background: ${colorTheme.tableV2.background};
			border-top: none;
			border-bottom: 3px solid ${colorTheme.tableV2.mobileBorderBold};
		}

		&:nth-child(even) {
			background: ${colorTheme.tableV2.background};
		}

		&.active {
			border-color: ${colorTheme.tableV2.border};
			box-shadow: none;
		}
	}
`
TableV2RowStyled.displayName = 'TableV2RowStyled'
